import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors } from "../ui/index.js";
export const AUDIT_FILTER_CATEGORIES = [
    { label: "Booking Preferences", prefix: "rule." },
    { label: "Permissions", prefix: "permission." },
    { label: "Credentials", prefix: "credential." },
    { label: "Sessions", prefix: "session." },
    { label: "Credits", prefix: "credit." },
];
/**
 * Multi-select filter chips. Each chip toggles a backend type prefix
 * (e.g. "rule.", "session.") in the `selected` array.
 *
 * The backend `types` query parameter takes a comma-separated list of
 * prefixes — selection is passed back via `onChange` as an array.
 */
export function AuditFilterChips({ selected, onChange }) {
    const toggle = (prefix) => {
        const isOn = selected.includes(prefix);
        onChange(isOn ? selected.filter((p) => p !== prefix) : [...selected, prefix]);
    };
    return (_jsxs("div", { role: "group", "aria-label": "Filter by audit type", style: { display: "flex", gap: 6, flexWrap: "wrap" }, children: [AUDIT_FILTER_CATEGORIES.map((cat) => {
                const active = selected.includes(cat.prefix);
                return (_jsx("button", { type: "button", "aria-pressed": active, onClick: () => toggle(cat.prefix), style: {
                        border: `1px solid ${active ? colors.primary : colors.border}`,
                        background: active ? colors.primary : colors.surface,
                        color: active ? colors.surface : colors.text,
                        borderRadius: 999,
                        padding: "4px 12px",
                        fontSize: "0.8rem",
                        fontWeight: 500,
                        cursor: "pointer",
                        transition: "background 0.15s, color 0.15s, border-color 0.15s",
                    }, children: cat.label }, cat.prefix));
            }), selected.length > 0 && (_jsx("button", { type: "button", onClick: () => onChange([]), style: {
                    border: "none",
                    background: "none",
                    color: colors.textSecondary,
                    fontSize: "0.8rem",
                    padding: "4px 6px",
                    cursor: "pointer",
                }, children: "Clear" }))] }));
}
